
export const environment = (window as any).SQUPRELEASEVARS?.Environment;

export const isProd = ['Production', 'ProductionEU', 'ProductionUK'].includes(environment);

export const isTestEnvironment = (window as any).Cypress || false;